module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leads-filtering"
  }, [_c('div', {
    staticClass: "leads-filtering--sync-status"
  }, [(_vm.$store.getters.getOrganizationConfig('crm_presence')) ? _c('div', {
    staticClass: "leads-filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.sync_status')))]), _vm._v(" "), (_vm.newFilters.sync_status) ? _c('field', {
    staticClass: "is-inline",
    attrs: {
      "type": "checkbox",
      "name": "sync_status",
      "label": " ",
      "model": "leads",
      "collection": _vm.syncStatusCollection
    },
    model: {
      value: (_vm.newFilters.sync_status.value),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.sync_status, "value", $$v)
      },
      expression: "newFilters.sync_status.value"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "leads-filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.origin')))]), _vm._v(" "), (_vm.newFilters.origin) ? _c('field', {
    staticClass: "is-inline",
    attrs: {
      "type": "checkbox",
      "name": "origin",
      "label": " ",
      "model": "leads",
      "collection": _vm.originCollection
    },
    model: {
      value: (_vm.newFilters.origin.value),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.origin, "value", $$v)
      },
      expression: "newFilters.origin.value"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "leads-filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.import_origin')))]), _vm._v(" "), (_vm.newFilters.import_origin) ? _c('field', {
    staticClass: "is-inline",
    attrs: {
      "type": "checkbox",
      "name": "importOrigin",
      "label": " ",
      "model": "leads",
      "collection": _vm.importOriginCollection
    },
    model: {
      value: (_vm.newFilters.import_origin.value),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.import_origin, "value", $$v)
      },
      expression: "newFilters.import_origin.value"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.$store.getters.getOrganizationConfig('crm_presence')) ? _c('div', {
    staticClass: "leads-filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.sync_disabled')))]), _vm._v(" "), (_vm.newFilters.sync_disabled) ? _c('field', {
    staticClass: "is-inline",
    attrs: {
      "type": "checkbox",
      "name": "sync_disabled",
      "label": " ",
      "model": "leads",
      "collection": _vm.syncDisabledCollection
    },
    model: {
      value: (_vm.newFilters.sync_disabled.value),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.sync_disabled, "value", $$v)
      },
      expression: "newFilters.sync_disabled.value"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "leads-filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.start_date')))]), _vm._v(" "), _c('div', {
    staticClass: "field grid has-gutter-xl"
  }, [(_vm.newFilters.start_date) ? _c('datepicker', {
    attrs: {
      "clear-button": true,
      "input-class": "input--datepicker",
      "id": "start_date",
      "name": "start_date",
      "language": _vm.getDatePickerLanguage()
    },
    model: {
      value: (_vm.newFilters.start_date.start),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.start_date, "start", $$v)
      },
      expression: "newFilters.start_date.start"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newFilters.start_date) ? _c('datepicker', {
    attrs: {
      "clear-button": true,
      "input-class": "input--datepicker",
      "id": "end_date",
      "name": "end_date",
      "language": _vm.getDatePickerLanguage()
    },
    model: {
      value: (_vm.newFilters.start_date.end),
      callback: function($$v) {
        _vm.$set(_vm.newFilters.start_date, "end", $$v)
      },
      expression: "newFilters.start_date.end"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "leads-filter--validate"
  }, [_c('a', {
    on: {
      "click": _vm.reset
    }
  }, [_c('button', {
    staticClass: "btn btn-tertiary"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.reset')))])]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.apply
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-save"
  }, [_vm._v(_vm._s(_vm.$t('ui.filters.apply')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc608dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Specific/LeadsFiltering.vue
// module id = 1898
// module chunks = 0